import {
  exists,
  defaultSystemCode,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface MailHistory {
  id: number
  type: SystemCode
  sendDateTime: string
  destination: string
  body: string
}

export const defaultMailHistory = (): MailHistory => ({
  id: 0,
  type: defaultSystemCode(),
  sendDateTime: '',
  destination: '',
  body: ''
})

export function MailHistoryFromJSON(json: any): MailHistory {
  const date = exists(json, 'send_date') ? json.send_date : ''
  const time = exists(json, 'send_time') ? json.send_time : ''

  return {
    id: json.id,
    type: exists(json, 'type')
      ? SystemCodeFromJSON(json.type)
      : defaultSystemCode(),
    sendDateTime: `${date} ${time}`,
    destination: exists(json, 'destination') ? json.destination : '',
    body: exists(json, 'body') ? json.body : ''
  }
}
